import React from "react";
import ReactDOM from "react-dom";
import App from "./components/App";
//import App from "./App";
import { BlockchainContextProvider } from "./store/BlockchainContext";
import { DepositModalContextProvider } from "./store/DepositModalContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

ReactDOM.render(
  <DepositModalContextProvider>
    <App />
    <ToastContainer />
  </DepositModalContextProvider>,
  document.getElementById("root")
);
